/******************************************************************
 * Archivo : client/src/queries/fetchUserById.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query UserByIdQuery($id: ID!) {
    userById(id: $id) {
      id

      email
      nombre
      apellido

      active
      validated
      tipoPerfil

      roles {
        id
        code
        label
      }

      person {
        tipo_de_documento
        documento_de_identidad
        lugar_de_expedicion
        fecha_de_nacimiento
        lugar_de_nacimiento
        pais_de_nacimiento
        genero
        raza
        grupo_etnico
        estado_civil
        nivel_educativo
        ocupacion
        direccion
        estrato
        ciudad
        localidad
        departamento
        pais_de_residencia
        telefono
        celular
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchUserById.js